import { newSpecPage } from '@stencil/core/testing'
import { CobaltDropdown } from '../cobalt-dropdown'

describe('cobalt-dropdown', () => {
  it('should render dropdown element', async () => {
    const page = await newSpecPage({
      components: [CobaltDropdown],
      html: '<cobalt-dropdown><cobalt-dropdown-section section-title="Section 3" format="selection" items=\'[ { "label": "Value 1", "value": "Value1" }, { "label": "Value 2", "value": "Value2" }, { "label": "Value 3", "value": "Value3" }]\'></cobalt-dropdown-section></cobalt-dropdown>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-dropdown>
        <core-dropdown alignment="center" width="small">
          <cobalt-dropdown-section format="selection" items="[ { &quot;label&quot;: &quot;Value 1&quot;, &quot;value&quot;: &quot;Value1&quot; }, { &quot;label&quot;: &quot;Value 2&quot;, &quot;value&quot;: &quot;Value2&quot; }, { &quot;label&quot;: &quot;Value 3&quot;, &quot;value&quot;: &quot;Value3&quot; }]" section-title="Section 3"></cobalt-dropdown-section>
        </core-dropdown>
      </cobalt-dropdown>
    `)
  })
})
